import { createReducer, on } from "@ngrx/store";
import { RemarkData } from "../../models/remarkDataModel";
import { fetchRemarksData, updateRemarksData, fetchRemarksError, deleteRemarksError, deleteRemarksSuccess } from "./admin.action";

export interface AdminState {
    fetchingRemarksData: boolean,
    remarksData: RemarkData[],
    error: string | null,
}

export const initialState: AdminState = {
    fetchingRemarksData: false,
    remarksData: [],
    error: null,
}

export const adminReducer = createReducer(
    initialState,
    on(fetchRemarksData, state => ({
        ...state,
        fetchingRemarksData: true,
        error: null,
        lastError: null
    })),
    on(updateRemarksData, (state, {remarksData}) => ({
        ...state,
        remarksData: remarksData,
        fetchingRemarksData: false,
        error: null,
        lastError: null
    })),
    on(fetchRemarksError, (state, {error}) => ({
        ...state,
        fetchingRemarksData: false,
        error: 'Kunde inte ladda anmärkningar',
    })),
    on(deleteRemarksError, (state, {error}) => ({
        ...state,
        error: 'Kunde inte ta bort anmärkning',
    })),
    on(deleteRemarksSuccess, (state, {id}) => ({
        ...state,
        remarksData: state.remarksData.filter(remark => remark.id !== id),
        error: null,
    }))
)
